import ReactDOM from 'react-dom/client';
import { type ReactNode } from 'react';

export const replaceHydrateFunction = () => {
  return (element: ReactNode, container: Element) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};
